/**
 * Utility functions for handling mention formats
 */

const MENTION_MARKUP = /(?:@|#)\[([^\]]+)\]\([^)]+\)/g;

/**
 * Extract plain text from mentions (removes formatting)
 * Converts `#[name](id)` or legacy `@[name](id)` to #name
 */
export const extractPlainTextFromMentions = (text: string): string => {
  return text.replace(MENTION_MARKUP, "#$1");
};

/**
 * Strips `#[name](id)` / `@[name](id)` to **label only** (no `#` or `@` prefix), for
 * plain text sent to the model or other backends that should not see markup or UI hints.
 */
export const extractMentionLabelsPlain = (text: string): string => {
  return text.replace(MENTION_MARKUP, "$1");
};

/**
 * Removes the trailing block of `#[label](document::id)` tokens appended after manuscript
 * disambiguation (see `appendDocumentMentionsForAmbiguousManuscriptQuestions`). Callers must
 * pass the persisted disambiguation marker so user-authored trailing mentions remain visible.
 */
export function stripTrailingDocumentMentionsFromDisplay(text: string, shouldStrip: boolean): string {
  if (!shouldStrip) return text;
  return text.replace(/(?:\r?\n){2}(?:(?:#\[[^\]]*\]\(document::[^)]+\))\s*)+$/u, "").trimEnd();
}
